import { setBookingReason } from './booking-reason.actions';
import { BookingReasonState, initialBookingReasonState } from './booking-reason.state';
import { createReducer, on } from '@ngrx/store';

export const bookingReasonReducer = createReducer(
  initialBookingReasonState,
  on(
    setBookingReason,
    (state, { bookingReason }): BookingReasonState => ({ ...state, bookingReason })
  )
);
